export default function () {
  return [
    {
      type: 'Input',
      title: '组织层级',
      [$field]: 'allName',
      colSpan: 16,
      rules: ['']
    },
    {
      type: 'Input',
      title: '所在团支部',
      [$field]: 'orgName',
      rules: ['']
    },
    {
      type: 'DatePicker',
      title: '入团日期',
      [$field]: 'expandFieldo',
      rules: ['']
    },
    {
      type: 'Input',
      title: '团内现任职务',
      [$field]: 'partyDuty',
      rules: ['']
    },
    {
      type: 'DatePicker',
      title: '任职时间',
      [$field]: 'jobTime',
      rules: []
    },
    {
      type: 'RemoteSelect',
      props: {
        url: 'api-general/module/portal/user/outGetList',
        map: {
          title: 'title',
          value: 'value'
        },
        params: {
          dictCode: 'KZ41',
          bizLineCode: 'YWX04',
          merge: false
        }
      },
      optionList: [],
      title: '是否在团市/区委注册志愿者',
      [$field]: 'expandFieldr',
      rules: ['']
    },
    {
      type: 'DatePicker',
      title: '成为注册志愿者时间',
      [$field]: 'expandFields',
      rules: []
    }
    // {
    //   type: 'RemoteSelect',
    //   title: '用户类型',
    //   [$field]: 'groupUserType',
    //   props: {
    //     url: 'api-general/module/portal/user/outGetList',
    //     map: {
    //       title: 'title',
    //       value: 'value'
    //     },
    //     params: {
    //       dictCode: 'BOE702',
    //       bizLineCode: 'YWX04',
    //       merge: false
    //     }
    //   },
    //   optionList: this.dictMap['BOE702'],
    //   rules: []
    // }
    // {
    //   type: 'RemoteSelect',
    //   props: {
    //     url: 'module/dict/outGetList',
    //     map: {
    //       title: 'title',
    //       value: 'value'
    //     },
    //     params: {
    //       dictCode: 'KZ41',
    //       merge: false
    //     }
    //   },
    //   optionList: [],
    //   title: '是否保留团籍的团干部',
    //   [$field]: 'isWorkOnSth',
    //   rules: ['']
    // },
    // {
    //   type: 'RemoteSelect',
    //   props: {
    //     url: 'module/dict/outGetList',
    //     map: {
    //       title: 'title',
    //       value: 'value'
    //     },
    //     params: {
    //       dictCode: 'KZ41',
    //       merge: false
    //     }
    //   },
    //   optionList: [],
    //   title: '是否推优入党',
    //   [$field]: 'expandFieldw',
    //   rules: ['']
    // },
    // {
    //   type: 'RemoteSelect',
    //   props: {
    //     url: 'module/dict/outGetList',
    //     map: {
    //       title: 'title',
    //       value: 'value'
    //     },
    //     params: {
    //       dictCode: 'KZ41',
    //       merge: false
    //     }
    //   },
    //   optionList: [],
    //   title: '是否保留团籍党员',
    //   [$field]: 'expandFieldx',
    //   rules: ['']
    // }
    // ,
    // {
    //   type: 'DatePicker',
    //   title: '入党时间',
    //   [$field]: 'joinPartyDate',
    //   rules: []
    // }
  ]
}